<template>
  <div ref="space_utilization_top10" id="space_utilization_top10"></div>
</template>

<script>
import * as echarts from "echarts";
import {
  space_utilization_top10,
  // events_tableData,
} from "../api/getData";
import { color_list } from "../config/env";

export default {
  data() {
    return {
      // envData: {},
      colors: {
        text_info: "#eee",
        text_alert: "#eee",
      },
      utilization_data: {},
      chart_option: {},
    };
  },
  methods: {
    //渲染事件报告折线图
    makeOption(request_data) {
      //定义全局变量FFC859
      let events_colors = color_list;
      //图表横坐标
      const dimensions = Object.values(request_data["dimensions"]);
      const source = Object.values(request_data["source"]);
      //定义option
      let option = {
        color: events_colors,
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          snap: true,
          order: "valueDesc",
          extraCssText: "z-index:2",
          position: { left: 10, top: 30 },
        },
        valueFormatter: (value) => value + "%",
        legend: { show: false },
        grid: {
          x: 0,
          y: 0,
          x2: 0,
          y2: 20,
          containLabel: true,
        },
        xAxis: {
          type: "category",
        },
        yAxis: {
          // name: this.utilization_data.traffic_unit,
          nameTextStyle: {
            color: "#aaa",
            nameLocation: "end",
          },
          axisLabel: {
            // formatter: function (value) {
            // return value + 'kb/s';
            //   return value;
            // },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "gray",
              opacity: 0.1,
            },
          },
          type: "value",
        },
        dataset: {
          dimensions: dimensions,
          source: source,
        },
        series: [
          { type: "line", smooth: true },
          { type: "line", smooth: true },
          { type: "line", smooth: true },
          { type: "line", smooth: true },
          { type: "line", smooth: true },
          // { type: "line", smooth: true  },
          // { type: "line", smooth: true  },
          // { type: "line", smooth: true  },
          // { type: "line", smooth: true  },
          // { type: "line", smooth: true  },
        ],
      };
      this.chart_option = option;
      return option;
    },
  },
  created() {},
  async mounted() {
    //初始化数据
    let request_data = await space_utilization_top10();
    this.utilization_data = request_data.data.data.space_utilization_top10;
    var utilizationLineChart = echarts.init(this.$refs.space_utilization_top10);
    utilizationLineChart.setOption(this.makeOption(this.utilization_data));
    // console.log(this.utilization_data);
    //定时更新
    setInterval(() => {
      space_utilization_top10().then((data) => {
        this.chart_option.dataset.dimensions = Object.values(
          data.data.data.space_utilization_top10.dimensions
        );
        this.chart_option.dataset.source = Object.values(
          data.data.data.space_utilization_top10.source
        );
        utilizationLineChart.setOption(this.chart_option);
      });
    }, 60000);
  },
};
</script>

<style lang="less">
@import "../style/mixin";

#space_utilization_top10 {
  height: 100%;
  flex: 3;
  align-content: end;
  font-family: "LCdd" !important;
}
</style>
